import React, { lazy, Component } from 'react';
import { GiftIcon, CheckIcon } from 'lucide-react';
// Componente de imagen con lazy loading
const LazyImage = ({
  src,
  alt,
  className
}) => {
  return <img src={src} alt={alt} className={className} loading="lazy" data-id="element-14" />;
};
export function Bonuses() {
  return <section className="py-16 bg-white" data-id="element-15">
      <div className="container mx-auto px-4" data-id="element-16">
        <div className="max-w-4xl mx-auto" data-id="element-17">
          <div className="text-center mb-12" data-id="element-18">
            <span className="inline-block bg-amber-100 text-amber-800 font-medium px-4 py-2 rounded-full mb-4" data-id="element-19">
              BONOS EXCLUSIVOS
            </span>
            <h2 className="text-3xl md:text-4xl font-bold text-amber-800 mb-4" data-id="element-20">
              ¡Además, hoy recibes estos bonos GRATIS!
            </h2>
            <p className="text-amber-700 text-lg" data-id="element-21">
              Con tu compra del recetario principal, obtienes estos 2 recursos
              adicionales sin costo extra (valorados en $19.94)
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-22">
            {/* Bono 1 */}
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl overflow-hidden shadow-lg" data-id="element-23">
              <div className="p-6" data-id="element-24">
                <div className="flex justify-between items-start mb-4" data-id="element-25">
                  <span className="bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-26">
                    BONO #1
                  </span>
                  <span className="bg-white text-amber-800 text-xs font-bold px-3 py-1 rounded-full border border-amber-200" data-id="element-27">
                    Valor: $9.97
                  </span>
                </div>
                <div className="flex justify-center mb-6" data-id="element-28">
                  <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/c6TWiTEY9qtqUS8rN2f2CE/Generated_Image_September_11%2C_2025_-_6_13PM.png" alt="Recetario Exprés de Lunchbox para Niños" className="w-48 h-48 object-cover rounded-lg shadow-md" data-id="element-29" />
                </div>
                <h3 className="text-xl font-bold text-amber-800 mb-3" data-id="element-30">
                  Recetario Exprés de Lunchbox para Niños
                </h3>
                <p className="text-amber-700 mb-4" data-id="element-31">
                  Un recetario adicional con 15 snacks exclusivos y fáciles para
                  la lonchera escolar.
                </p>
                <ul className="space-y-2" data-id="element-32">
                  <BonusFeature text="Recetas dulces y saladas." data-id="element-33" />
                  <BonusFeature text="Opciones sin azúcar refinada." data-id="element-34" />
                  <BonusFeature text="Ideas que los niños realmente disfrutan y comen sin quejas." data-id="element-35" />
                </ul>
              </div>
            </div>
            {/* Bono 2 */}
            <div className="bg-gradient-to-br from-amber-50 to-amber-100 rounded-xl overflow-hidden shadow-lg" data-id="element-36">
              <div className="p-6" data-id="element-37">
                <div className="flex justify-between items-start mb-4" data-id="element-38">
                  <span className="bg-amber-600 text-white text-xs font-bold px-3 py-1 rounded-full" data-id="element-39">
                    BONO #2
                  </span>
                  <span className="bg-white text-amber-800 text-xs font-bold px-3 py-1 rounded-full border border-amber-200" data-id="element-40">
                    Valor: $9.97
                  </span>
                </div>
                <div className="flex justify-center mb-6" data-id="element-41">
                  <LazyImage src="https://uploadthingy.s3.us-west-1.amazonaws.com/g15qyb9FSHazeugqHUoebL/ChatGPT_Image_Sep_11%2C_2025%2C_05_08_24_PM.png" alt="Guía de Compras Inteligentes en el Súper" className="w-48 h-48 object-cover rounded-lg shadow-md" data-id="element-42" />
                </div>
                <h3 className="text-xl font-bold text-amber-800 mb-3" data-id="element-43">
                  Guía de Compras Inteligentes en el Súper
                </h3>
                <p className="text-amber-700 mb-4" data-id="element-44">
                  Un mini-ebook que te enseña a comprar rápido y barato sin
                  sacrificar calidad.
                </p>
                <ul className="space-y-2" data-id="element-45">
                  <BonusFeature text="Listas de compra ya organizadas por categorías." data-id="element-46" />
                  <BonusFeature text="Trucos para ahorrar hasta un 30% en el súper." data-id="element-47" />
                  <BonusFeature text="Opciones de sustitutos saludables para cada receta." data-id="element-48" />
                </ul>
              </div>
            </div>
          </div>
          <div className="mt-12 text-center" data-id="element-49">
            <div className="inline-flex items-center justify-center bg-amber-100 text-amber-800 font-bold px-6 py-3 rounded-full mb-6" data-id="element-50">
              <GiftIcon className="h-5 w-5 mr-2" data-id="element-51" />
              <span data-id="element-52">Valor total de bonos: $19.94 - HOY GRATIS</span>
            </div>
            <p className="text-amber-700 mb-8" data-id="element-53">
              Estos bonos exclusivos te ayudarán a simplificar aún más tu rutina
              diaria, desde los almuerzos escolares hasta tus compras semanales.
            </p>
            <a href="https://productivetips.com/cart/45129127657658:1?checkout" className="bg-amber-700 hover:bg-amber-800 text-white font-bold py-3 px-8 rounded-lg shadow-md text-lg transition duration-300 inline-block" data-id="element-54">
              Comprar ahora - Solo $9.97
            </a>
            <p className="mt-2 text-amber-700 text-sm font-medium" data-id="element-55">
              <span className="line-through" data-id="element-56">$29.91</span> • Ahorras $19.94
            </p>
          </div>
        </div>
      </div>
    </section>;
}
function BonusFeature({
  text
}) {
  return <div className="flex items-start space-x-2" data-id="element-57">
      <CheckIcon className="h-5 w-5 text-amber-600 flex-shrink-0 mt-0.5" data-id="element-58" />
      <p className="text-amber-800" data-id="element-59">{text}</p>
    </div>;
}